import { ITelemetry } from '../telemetry';
import { useInternalTelemetry } from './useInternalTelemetry';

export const useSetTelemetry = (): React.Dispatch<React.SetStateAction<ITelemetry>> => {
  const context = useInternalTelemetry();

  return context.setTelemetry;
};
